module.exports = __webpack_public_path__ + "img/background_login.babacc1d.svg";